import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import TestDeviceAssignationsListPage from "@/pages/games/GameDisplay/children/testers/TestDeviceAssignationsList/TestDeviceAssignationsListPage.vue";

import links from "./links";

const { canReadTesters } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: TestDeviceAssignationsListPage,
    name: links.games.testDevices.list,
    props: true,
    meta: {
      title: "Test device assignations",
      permission: canReadTesters,
    },
  },
];
